import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { validateContactNo } from "../../common/validation";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import Loader from "react-loader-spinner";
import {
  UpdateCartCount,
  UpdateCartAmount,
} from "../../redux/actions/postActions";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import { Md5 } from "md5-typescript";
import { DH_CHECK_P_NOT_SAFE_PRIME } from "constants";
function ResetPassword(props) {
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [showPasswordError2, setShowPasswordError2] = useState(false);
  const [password_type, setPasswordType] = useState(true);
  const [password_type2, setPasswordType2] = useState(true);
  const [password_error, setPasswordError] = useState("");
  const [password_error2, setPasswordError2] = useState("");
  const [is_loading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [verificationCode, setVerification_code] = useState("");

  const passwordRef = useRef<any>();
  const confirmPasswordRef = useRef<any>();
  useEffect(() => {
    let veriCode = props?.location?.state?.verification_code;
    if (veriCode) {
      setVerification_code(veriCode);
    } else {
      props?.history?.goBack();
    }
  }, []);
  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        if (success) {
          props?.history?.push("/login", { from: "Reset Password" });
        } else {
          handleResetNewPassword();
        }
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [success, password]);
  const handlePassword = (event) => {
    setShowPasswordError(false);
    setPassword(event.target.value);
    if (password2 !== "") {
      if (event.target.value !== password2) {
        setShowPasswordError(true);
        setPasswordError("Password do not match");
        return;
      } else {
        setShowPasswordError(false);
        setShowPasswordError2(false);
      }
    }
    if (event.target.value.length < 8) {
      setShowPasswordError(true);
      setPasswordError("Your password should contain at least 8 characters");
      passwordRef.current.focus();
    }
  };
  const handlePassword2 = (event) => {
    setShowPasswordError2(false);
    setPassword2(event.target.value);
    if (event.target.value !== password) {
      setShowPasswordError2(true);
      setPasswordError2("Password do not match");
      confirmPasswordRef.current.focus();
    } else {
      setShowPasswordError(false);
      setShowPasswordError2(false);
    }
  };
  const ErrorView = (_text) => {
    return (
      <div
        className="error"
        style={{ display: "block", marginTop: 10, marginBottom: 10 }}
      >
        {_text}
      </div>
    );
  };

  const handleResetNewPassword = () => {
    setIsLoading(true);
    if (showPasswordError || showPasswordError2) {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
      return;
    }
    if (password == "" || password2 == "") {
      setIsLoading(false);
      return;
    }
    if (!showPasswordError2) {
      let c = verificationCode + password + "#frasers";
      let checksum = Md5.init(c);
      new WebApiCalls()
        .resetNewPassword(password, checksum, verificationCode)
        .then((response) => {
          if (response && response.data) {
            setSuccess(true);
          }
          setIsLoading(false);
        });
    }
  };

  return (
    <div>
      <div className="viewport"></div>

      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}

        <MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>

        {/* <!-- login --> */}
        <div className="login">
          <div className="title">Reset your password</div>

          <form action="index-loggedin.html" name="newpw">
            {!success && (
              <fieldset className="pw-field">
                <label htmlFor="">NEW PASSWORD</label>
                <input
                  type={password_type ? "password" : "text"}
                  name="newpw"
                  id="newpw"
                  onChange={handlePassword}
                  ref={passwordRef}
                />
                <div
                  className="visibility"
                  onClick={() => setPasswordType(!password_type)}
                >
                  <img
                    src={
                      password_type
                        ? "images/icon-invisible.svg"
                        : "images/icon-visible.svg"
                    }
                    alt=""
                  />
                </div>
                {showPasswordError && ErrorView(password_error)}
              </fieldset>
            )}
            {!success ? (
              <fieldset className="pw-field">
                <label htmlFor="">CONFIRM PASSWORD</label>
                <input
                  type={password_type2 ? "password" : "text"}
                  name="newpw"
                  id="newpw2"
                  onChange={handlePassword2}
                  ref={confirmPasswordRef}
                />
                <div
                  className="visibility"
                  onClick={() => setPasswordType2(!password_type2)}
                >
                  <img
                    src={
                      password_type2
                        ? "images/icon-invisible.svg"
                        : "images/icon-visible.svg"
                    }
                    alt=""
                  />
                </div>
                {showPasswordError2 && ErrorView(password_error2)}
              </fieldset>
            ) : (
              <div
                className="greynote"
                style={{ marginBottom: "50px", textAlign: "center" }}
              >
                Your password has been changed.
              </div>
            )}

            {!success && (
              <div
                className="loadingBlackButton"
                onClick={(event) => {
                  event.preventDefault();
                  if (!showPasswordError2 && !showPasswordError) 
                  handleResetNewPassword();
                }}
              >
                {is_loading ? (
                  <Loader
                    type="TailSpin"
                    color="white"
                    height={18}
                    width={18}
                  />
                ) : (
                  "RESET PASSWORD"
                )}
              </div>
            )}
            {success && (
              <div
                className="loadingBlackButton"
                onClick={(event) => {
                  props?.history?.push("/login", { from: "Reset Password" });
                }}
              >
                {"SIGN IN"}
              </div>
            )}
          </form>

          {!success && (
            <div
              className="join"
              onClick={() =>
                props?.history?.push("/login", { from: "Reset Password" })
              }
            >
              <a>Back to Sign In Page</a>
            </div>
          )}
        </div>
        {/* <!-- /login --> */}
      </div>
      {/* /container */}

      <Footer categoriesArray={props?.allCategories ? props?.allCategories : []}/>
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count,allCategories } = state.UserReducer;
  return { cart_count,allCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
};
export default connect(mapStateToProps, actions)(ResetPassword);
